<template>
    <div>
        <div class="row reports">
            <div class="col-lg-12 col-md-12">
                <!--         <div class="card">
                          <div class="card-content"> -->
                <vue-tabs  class="row reports-tabs full-height-tabs" direction="vertical" value="Description">
                    <!-- Trends Reports Tab -->
                    <v-tab :title="$t('reports.trends')" icon="icon-report icon-report-trends">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="pull-left mar-rt-10" v-if="showLocations">
                                  <span class="pad-rg-5">{{$t('dashboard.selectLocation')}}</span> 
                                  <select class="form-control inline-auto white " @change="updateData" v-model="model.trends.location">
                                    <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
                                    <template v-for="(loc, key) in locations" >
                                      <option  :label="loc.name"
                                                    :value="loc.id"
                                                    :key="loc.id"
                                                    > {{loc.name}}
                                      </option>
                                    </template>
                                  </select>
                                </div>
                                <p class="pull-left ">
                                    <el-date-picker 
                                                    type="daterange"
                                                    v-model="model.trends.valid"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    :name="pickerNames"
                                                    :picker-options="pickerOptions1"
                                                    @change="updateData">
                                    </el-date-picker>
                                </p>
                            </div>
                        </div>
                        <div class="row text-left">
                            <!-- Orders Chart -->
                            <div class="col-md-12">
                                <chart-card :chart-data="ordersChart.data" :chart-options="ordersChart.options" ref="refOrdersChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.orderChart')}}</h4>
                                        <p class="category">{{ordersChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <i class="fa fa-circle text-info"></i> {{$t('dashboard.completed')}}
                                            <!-- <i class="fa fa-circle text-warning"></i> {{$t('reports.canceled')}} -->
                                        </div>
                                    </div>
                                </chart-card>
                            </div>
                            <!-- Sales chart -->
                            <div class="col-md-12">
                                <chart-card :chart-data="salesChart.data" :chart-options="salesChart.options" ref="salesChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.salesChart')}}</h4>
                                        <p class="category">{{salesChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <i class="fa fa-circle text-info"></i> {{$t('reports.salesIn')}} {{currency}}
                                        </div>
                                    </div>
                                </chart-card>
                            </div>
                        </div>
                        <div class="row text-left">
                            <div class="col-md-12" v-if="!this.model.trends.location">
                                <chart-card :chart-data="customersChart.data" :chart-options="customersChart.options" ref="customersChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.customersChart')}}</h4>
                                        <p class="category">{{customersChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <i class="fa fa-circle text-info"></i> {{$t('reports.custWithAcc')}}
                                            <!-- <i class="fa fa-circle text-warning"></i> {{$t('reports.custWithAcc')}} -->
                                        </div>
                                    </div>
                                </chart-card>
                            </div>
                            <div class="col-md-6">
                                <chart-bars-card :chart-data="deliveryChart.data" :chart-options="deliveryChart.options" ref="deliveryChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.orderingChart')}}</h4>
                                        <p class="category">{{deliveryChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <i class="fa fa-circle text-info"></i> {{$t('reports.nrOfOrders')}}
                                        </div>
                                    </div>
                                </chart-bars-card>
                            </div>
                        
                            <div class="col-md-6">
                                <chart-bars-card :chart-data="topProdsChart.data" :chart-options="topProdsChart.options" ref="topProdsChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.top10Chart')}}</h4>
                                        <p class="category">{{topProdsChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <i class="fa fa-circle text-info"></i> {{$t('reports.salesIn')}} {{currency}}
                                        </div>
                                    </div>
                                </chart-bars-card>
                            </div>
                        </div>
                        <div class="row text-left" v-if="!this.model.trends.location">
                            <div class="col-md-6">
                                <chart-pie-card :chart-data="ageChart.data" :chart-options="ageChart.options" ref="ageChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.customersAge')}}</h4>
                                        <p class="category">{{ageChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <p> </p>
                                        </div>
                                    </div>
                                </chart-pie-card>
                            </div>
                            <div class="col-md-6" > 
                                <chart-pie-card :chart-data="genderChart.data" :chart-options="genderChart.options" ref="genderChart">
                                    <div slot="header">
                                        <h4 class="card-title">{{$t('reports.customersGender')}}</h4>
                                        <p class="category">{{genderChart.title}}</p>
                                    </div>
                                    <div slot="footer">
                                        <div class="chart-legend">
                                            <p> </p>
                                        </div>
                                    </div>
                                </chart-pie-card>
                            </div>
                        </div>
                    </v-tab>
                    <!-- END Trends Reports Tab -->

                    <!-- Clients Reports Tab -->
                    <v-tab v-if="false" :title="$t('reports.clients')" icon="icon-report icon-report-clients">
                        <div class="col-md-12 card text-left">
                            <div class="card-header"></div>
                            <div class="">
                                <select name="gender"
                                        
                                        class="form-control sml"
                                        v-model="filters[0].value"
                                >
                                    <option  selected=""  value=""> - {{$t('gender.selectGender')}} - </option>
                                    <option value="M">{{$t('gender.male')}}</option>
                                    <option value="F">{{$t('gender.female')}}</option>
                                </select>
                                <select name="age"
                                        placeholder=""
                                        class="form-control sml"
                                        v-model="filters[1].value"
                                >
                                    <option selected=""  value=""> - {{$t('reportsAgesGroups.selectAge')}} - </option>
                                    <option value="20">{{$t('reportsAgesGroups.20')}}</option>
                                    <option value="20-30">{{$t('reportsAgesGroups.20-30')}}</option>
                                    <option value="30-40">{{$t('reportsAgesGroups.30-40')}}</option>
                                    <option value="40-50">{{$t('reportsAgesGroups.40-50')}}</option>
                                    <option value="50+">{{$t('reportsAgesGroups.50')}}</option>
                                </select>
                    <!--             <select name="location"
                                        placeholder="Pick Location"
                                        class="form-control sml"
                                        v-model="filters[2].value"
                                        v-if="showLocations"
                                >
                                    <option selected=""  value=""> - Select Location - </option>
                                    <option v-for="(loc, key) in locations" :value="loc.id">{{loc.name}}</option>
                                </select> -->
                                <el-date-picker type="daterange"
                                                v-model="model.trends.valid"
                                                class="mid"
                                                format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                :name="pickerNames"
                                                :picker-options="pickerOptions1"
                                                @change="updateData">
                                </el-date-picker>
                         <!--        <JsonExcel :data="clientsExportData"  v-bind:name="'clients_ ' + todaysDate "  class="pull-right btn btn-purple">{{$t('general.export')}}</JsonExcel> -->
                            </div>
                            <div class="card-content row">
                                <data-tables class=""
                                            v-loading="loading"
                                             :data="clientsTableData"
                                             :search-def="{show: false}"
                                             :action-def="defaultActionDef"
                                             :pagination-def="paginationDef"
                                             :filters="filters"
                                             @row-click="goToRecordCustomer"
                                             style="width: 100%">
                                    <el-table-column :min-width="80" sortable  :label="$t('reports.name')">
                                        <template slot-scope="props">
                                            {{ props.row.firstname}} {{ props.row.lastname }}
                                        </template>
                                     </el-table-column>
                                    <el-table-column :min-width="80" sortable prop="created_at" :label="$t('reports.appInstalls')"> </el-table-column>
                                    <el-table-column :min-width="80" sortable prop="gender" :label="$t('reports.gender')"> </el-table-column>
                                    <el-table-column :min-width="80" sortable prop="location" :label="$t('reports.location')"> </el-table-column>
                                    <el-table-column :min-width="80" sortable prop="email" :label="$t('reports.email')"> </el-table-column>
                                    <el-table-column :min-width="80" sortable prop="phone" :label="$t('reports.phone')"> </el-table-column>
                                    <el-table-column
                                            :min-width="80"
                                            sortable
                                            prop="purchases"
                                            :label="$t('reports.totalAmount')">
                                        <template slot-scope="props">
                                            <b>{{formatMoneyAmount(props.row.sales)}}</b>
                                        </template>
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </div>
                    </v-tab>
                    <!-- END Clients Reports Tab -->

                    <!-- Products Reports Tab -->
                    <v-tab v-if="false" :title="$t('reports.products')" icon="icon-report icon-report-prod" >
                            <div class="col-md-12 card text-left">
                                <div class="card-header"></div>
                                <div class="">
                                    <el-date-picker type="daterange"
                                                v-model="model.trends.valid"
                                                class="mid"
                                                format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                :name="pickerNames"
                                                :picker-options="pickerOptions1"
                                                @change="updateData">
                                    </el-date-picker>
                            <!--         <JsonExcel :data="productsTableData"  v-bind:name="'products_ ' + todaysDate" class="pull-right btn btn-purple">{{$t('general.export')}}</JsonExcel> -->
                                </div>
                                <div class="card-content row">
                                    <data-tables class=""
                                                v-loading="loading"
                                                 :data="productsTableData"
                                                 :search-def="{show: false}"
                                                 :action-def="defaultActionDef"
                                                 :pagination-def="paginationDef"
                                                 :table-props="{'border': false}"
                                               
                                                 style="width: 100%">
                                        <el-table-column
                                                :min-width="100"
                                                sortable
                                                :label="$t('reports.name')">
                                          <template slot-scope="props">
                                            {{ props.row.name}}
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                                :min-width="100"
                                                sortable
                                                :label="$t('reports.itemsSold')">
                                          <template slot-scope="props">
                                            {{ props.row.items_sold}}
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                                :min-width="80"
                                                sortable
                                                :label="$t('reports.totalAmount')">
                                            <template slot-scope="props">
                                                <b>{{formatMoneyAmount(props.row.total_amount, props.row.currency_iso)}}</b>
                                            </template>
                                        </el-table-column>
                                    </data-tables>
                                </div>
                            </div>
                        </v-tab>
                        <!-- END Products Reports Tab -->

                        <!-- Marketing Reports Tab -->
                        <v-tab v-if="false" :title="$t('reports.marketing')" icon="icon-report icon-report-marketing">
                            <div class="col-md-12 card text-left">
                                <div class="card-header"></div>
                                <div class="clearfix">
                                    <el-date-picker type="daterange"
                                                v-model="model.trends.valid"
                                                class="mid"
                                                format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                :name="pickerNames"
                                                :picker-options="pickerOptions1"
                                                @change="updateData">
                                    </el-date-picker>
                              <!--     <JsonExcel :data="campaignsTableData"  v-bind:name="'marketing_ ' + todaysDate" class="pull-right btn btn-purple">{{$t('general.export')}}</JsonExcel> -->
                                </div>
                                <div  class="card-content row" >
                                    <data-tables class=""
                                                v-loading="loading"
                                                 :data="campaignsTableData"
                                                 :search-def="{show: false}"
                                                 :action-def="defaultActionDef"
                                                 :pagination-def="paginationDef"
                                                 :table-props="{'border': false}"
                                                 style="width: 100%"
                                                 ref="campaignsTable">
                                        <el-table-column
                                                :min-width="100"
                                                sortable
                                                prop="name"
                                                :label="$t('reports.campaign')">
                                        </el-table-column>
                                        <el-table-column
                                                :min-width="100"
                                                sortable
                                                prop="coupons_time_used"
                                                :label="$t('reports.couponsTimesUsed')">
                                        </el-table-column>
                                        <el-table-column
                                                :min-width="80"
                                                sortable
                                                prop="revenue"
                                                :label="$t('reports.revenue')">
                                            <template slot-scope="props">
                                                <b>{{formatMoneyAmount(props.row.revenue, props.row.currency)}}</b>
                                            </template>
                                        </el-table-column>
                                    </data-tables>
                                </div>
                            </div>
                        </v-tab>
                        <!-- END Marketing Reports Tab -->

                </vue-tabs>
                <!--  </div>
               </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {Collapse, CollapseItem, DatePicker} from 'element-ui'
    import VueTabs from 'vue-nav-tabs'
    import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
    import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
    import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
    import moment from 'moment'
    // import JsonExcel from 'vue-json-excel'

    Vue.use(VueTabs)
    Vue.use(Collapse)
    Vue.use(CollapseItem)
    // Vue.use(DatePicker)
    // Vue.use(JsonExcel)
    export default {
      components: {
        [DatePicker.name]: DatePicker,
        ChartCard,
        ChartBarsCard,
        ChartPieCard
        // JsonExcel
      },
      created () {
        this.locations = this.$session.get('selectedCompanyData').locations_details
        if (this.locations.length > 1) {
          this.showLocations = true
          let filterCookie = this.$cookie.get('filter-locations')
          if (filterCookie) {
            filterCookie = JSON.parse(filterCookie)
            this.model.trends.location = filterCookie[0]
          }
        }

        this.getData()

        this.filters[3]['value'] = [this.model.trends.valid[0], this.model.trends.valid[1]]
      },
      data () {
        return {
          loading: true,
          currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
          model: {
            trends: {
              'valid': [
                moment().date(1).format('YYYY-MM-DD'),
                moment().endOf('month').format('YYYY-MM-DD')
              ],
              location: ''
            }
          },
          locations: [],
          showLocations: false,
          selectedLocation: '',
          todaysDate: this.currentDate(),
          json_meta: [
            [
              {
                'key': 'charset',
                'value': 'utf-8'
              }
            ]
          ],
          filters: [
            {
              default: 'Select gender',
              value: '',
              filterFn: (row, filter) => {
                return Object.keys(row).some(prop => {
                  if (row.gender.toLowerCase() === filter.value.toLowerCase()) {
                    return filter.value
                  }
                })
              }
            },
            {
              value: '',
              filterFn: (row, filter) => {
                return Object.keys(row).some(prop => {
                  var age = this.getAge(row.birthdate)
                  switch (filter.value) {
                    case '20':
                      if (age < 20) {
                        return row
                      }
                      break
                    case '20-30':
                      if (age >= 20 && age <= 30) {
                        return row
                      }
                      break
                    case '30-40':
                      if (age >= 30 && age <= 40) {
                        return row
                      }
                      break
                    case '40-50':
                      if (age >= 40 && age <= 50) {
                        return row
                      }
                      break
                    case '50+':
                      if (age > 50) {
                        return row
                      }
                      break
                  }
                })
              }
            },
            {
              value: '',
              prop: 'location'
            },
            {
              value: [],
              filterFn: (row, filter) => {
                var date1 = moment(filter.value[0]).format('X')
                var date2 = moment(filter.value[1]).format('X')
                var installedDate = (row.created_at) ? moment(row.created_at).format('X') : ''
                var productDate = (row.date) ? moment(row.date).format('X') : ''
                return Object.keys(row).some(prop => {
                  if (installedDate >= date1 && installedDate <= date2) {
                    return row
                  }
                  if (productDate >= date1 && productDate <= date2) {
                    return row
                  }
                })
              }
            }
          ],
          paginationDef: {
            pageSize: 99999,
            currentPage: 1,
            pageSizes: [99999],
            show: false
          },
          pickerNames: ['date_from', 'date_to'],
          pickerOptions1: {},
          activeName: 'first',
          productsTableData: [],
          campaignsTableData: [],
          clientsTableData: [],
          clientsExportData: [],
          ordersChart: {
            title: '',
            data: {
              labels: [],
              series: []
            },
            options: {
              seriesBarDistance: 10,
              axisX: {
                showGrid: false
              },
              height: '200px'
            }
          },
          customersChart: {
            title: '',
            data: {
              labels: [],
              series: []
            },
            options: {
              seriesBarDistance: 10,
              axisX: {
                showGrid: false
              },
              height: '200px'
            }
          },
          salesChart: {
            title: '',
            data: {
              labels: [],
              series: []
            },
            options: {
              showArea: true,
              height: '200px',
              axisX: {
                showGrid: false
              },
              showLine: true
            }
          },
          topProdsChart: {
            // title: 'Last 12 monts',
            data: {
              labels: [],
              series: []
            },
            options: {
              seriesBarDistance: 20,
              showArea: true,
              height: '300px',
              axisX: {
                showGrid: false
              }
            }
          },
          deliveryChart: {
            // title: 'Last 12 monts',
            data: {
              labels: [],
              series: []
            },
            options: {
              seriesBarDistance: 10,
              showArea: true,
              height: '300px',
              axisX: {
                showGrid: false
              }
            }
          },
          ageChart: {
            // title: 'Last 12 monts',
            data: {
              labels: [],
              series: []
            },
            options: {
              showArea: true,
              height: '250px'
            }
          },
          genderChart: {
            // title: 'Last 12 monts',
            data: {
              labels: [],
              series: []
            },
            options: {
              showArea: true,
              height: '250px'
            }
          }
        }
      },
      methods: {
        getData () {
          var self = this
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            start_date: this.model.trends.valid[0],
            end_date: this.model.trends.valid[1]
          }
          if (this.model.trends.location && this.model.trends.location !== '') {
            data.location_id = this.model.trends.location
          }
          self.loading = true
          this.apiRequest('/reports/trends', 'GET', data, function (response) {
            if (response.status === true) {
              self.ordersChart.data.labels = response.data.orders.labels
              self.ordersChart.data.series = [response.data.orders.delivered]
              self.ordersChart.title = self.$t('reports.total') + ' ' + response.data.counters.total_orders
              // self.ordersChart.data.canceled = response.data.orders.canceled
              // self.ordersChart.data.delivered = response.data.orders.delivered
              self.$refs.refOrdersChart.initChart()

              self.customersChart.data.labels = response.data.customers.labels
              self.customersChart.data.series = [response.data.customers.values]
              self.customersChart.title = self.$t('reports.total') + ' ' + response.data.counters.customers
              self.$refs.customersChart.initChart()

              self.salesChart.data.labels = response.data.sales.labels
              self.salesChart.data.series = [response.data.sales.values]
              self.salesChart.title = self.$t('reports.total') + ' ' + response.data.counters.revenue
              self.$refs.salesChart.initChart()

              self.topProdsChart.data.labels = response.data.top_products['labels']
              self.topProdsChart.data.series = [response.data.top_products['values']]
              self.$refs.topProdsChart.initChart()

              self.deliveryChart.data.labels = response.data.delivery_types.labels
              self.deliveryChart.data.series = [response.data.delivery_types.values]
              self.$refs.deliveryChart.initChart()

              let customersAgeLb = []
              if (response.data.customers_age.labels.length) {
                customersAgeLb = response.data.customers_age.labels.map(function (val) {
                  val = self.$t('reportsAgesGroups.' + val)
                  return val
                })
              }
              self.ageChart.data.labels = customersAgeLb
              self.ageChart.data.series = response.data.customers_age.series
              if (response.data.customers_age.labels.length) {
                self.$refs.ageChart.initChart()
              }

              let customersGenderLb = []
              if (response.data.customers_gender.labels.length) {
                customersGenderLb = response.data.customers_gender.labels.map(function (val) {
                  val = self.$t('gender.' + val)
                  return val
                })
              }
              console.warn(self.$refs)
              self.genderChart.data.labels = customersGenderLb
              self.genderChart.data.series = response.data.customers_gender.series
              if (response.data.customers_gender.labels.length) {
                self.$refs.genderChart.initChart()
              }

              self.productsTableData = response.data.products
              self.campaignsTableData = response.data.marketing
              // self.$refs.campaignsTable.tableData()
              // self.$refs.campaignsTable.data = response.data.marketing
            }
            self.$nextTick(function () {
              self.loading = false
            })
          })

          this.apiRequest('/customer', 'GET', data, function (response) {
            if (response.status === true) {
              console.log(response.data)
              self.clientsTableData = response.data

              for (let customer of response.data) {
                self.clientsExportData.push({
                  'FirstName': customer.firstname,
                  'LastName': customer.lastname,
                  'Email': customer.email,
                  'Phone': customer.phone,
                  'Gender': customer.gender,
                  'Birthdate': customer.birthdate,
                  'Sales': self.formatMoneyAmount(customer.sales, '')
                })
              }
            }
            self.$nextTick(function () {
              self.loading = false
            })
          })
        },
        updateData () {
          this.getData()
          this.$cookie.set('filter-locations', JSON.stringify([this.model.trends.location]), 1)
        },
        goToRecordCustomer (row, event, column) {
          this.globalGoToRecord(row, event, column, '/reports/customer/')
        },
        daysBetween (date1, date2) {
          var oneDay = 1000 * 60 * 60 * 24
          var date1Ms = date1.getTime()
          var date2Ms = date2.getTime()
          var differenceMs = date2Ms - date1Ms
          return Math.round(differenceMs / oneDay)
        },
        firstDayofMonth () {
          var date = new Date()
          var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
          return firstDay
        },
        lastDayofMonth () {
          var date = new Date()
          var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
          return lastDay
        },
        currentDate () {
          return moment().format('DD-MM-YYYY') + '.xls'
        },
        tabClicked (selectedTab) {
          console.warn('test')
          console.warn('Current tab re-clicked:' + selectedTab.tab.title)
        },
        tabChanged (selectedTab) {
          console.warn('Tab changed to:' + selectedTab.tab.title)
        }
      }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Reports.vue